import React from "react";
import CoupangIcon from "../../assets/icons/commons/coupang.svg";
import { useDeepLinkCoupon } from "core/hooks/useDeeplinkCoupon";
import LoadingCoupang from "./Loading";

interface CoupangProps {
  ingredient_id: number;
}

const Coupang: React.FC<CoupangProps> = ({ ingredient_id }) => {
  const backRef = React.useRef<any>(null);
  const _onSuccess = (data: any) => {
    const url: string = data[0]?.landingUrl;
    if (url && typeof url === "string" && url.trim() !== "") {
      (window as any).webViewOpenBrowser(url);
      backRef.current = (window as any).backFromDeviceAndroid;

      (window as any).backFromDeviceAndroid = function () {
        if (backRef.current) {
          (window as any).backFromDeviceAndroid = backRef.current
        }
      };
      // console.log((window as any).backFromDeviceAndroid);
    } else {
      console.log("Invalid URL:", url);
    }
  };

  const _onError = (error: any) => {
    console.log("error", error);
  };

  const { loading, handleFetchDeepLinkCoupon } = useDeepLinkCoupon({
    onSuccess: _onSuccess,
    onError: _onError,
  });

  const handleClick = () => {
    const data = {
      ingredient_id,
    };
    handleFetchDeepLinkCoupon(data);
  };

  return (
    <div className="relative inline-block">
      <img
        className={`${loading ? "opacity-50" : ""}`}
        src={CoupangIcon}
        alt=""
        onClick={handleClick}
      />
      <LoadingCoupang loading={loading} />
    </div>
  );
};

export default Coupang;
